import type { VisibilityFlags } from "../../engines/types";

/**
 * The layer state every design opens with. Owned here, next to the presets
 * built from it; `pages/builder/constants` re-exports it as DEFAULT_VIS.
 */
export const DEFAULT_VISIBILITY: VisibilityFlags = {
	foundation: true,
	deck: true,
	framing: true,
	panel: true,
	roof: true,
	frontWall: true,
	interior: true,
	exterior: true,
	// Inspection overlays — off by default; saved designs without the keys
	// hydrate to this via the DEFAULT_VIS spread in mappers.ts. The photo view
	// is the default, so the vent diagram colours start off.
	heaterClearance: false,
	ventilation: false,
};

export type VisibilityPresetId = "finished" | "framing" | "safety";

/**
 * Whole-view presets over the ten layer toggles: the three views a builder
 * actually reaches for. Each is a complete state, applied in one update.
 */
export const VISIBILITY_PRESETS: Record<VisibilityPresetId, VisibilityFlags> = {
	finished: DEFAULT_VISIBILITY,
	// The frame on its foundation: no cladding, panel, roof or interior.
	framing: {
		...DEFAULT_VISIBILITY,
		exterior: false,
		panel: false,
		roof: false,
		interior: false,
	},
	// The clearance and ventilation overlays, with the front wall open.
	safety: {
		...DEFAULT_VISIBILITY,
		frontWall: false,
		heaterClearance: true,
		ventilation: true,
	},
};

export function matchesPreset(
	visibility: VisibilityFlags,
	preset: VisibilityFlags,
): boolean {
	return (Object.keys(preset) as Array<keyof VisibilityFlags>).every(
		(key) => visibility[key] === preset[key],
	);
}
